// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"0960b410","327":"5c7a90f9","870":"c36360ba"}[chunkId] + ".chunk.css";
};